module.exports = __webpack_public_path__ + "img/send_2.30db6a69.png";